import {PAY_CONNECT_CDN_LOGOS} from './payConnectCdnLogos'

export type VendorGatewayLogoMeta = {
  logo: string
  color: string
  backgroundColor: string
  name: string
  type: 'wallet' | 'card'
  description: string
}

export const vendorGatewayLogos: Record<string, VendorGatewayLogoMeta> = {
  PY_WHISH: {
    logo: PAY_CONNECT_CDN_LOGOS.PY_WHISH,
    color: '#2D9CDB',
    backgroundColor: '#E3F2FD',
    name: 'Whish Money',
    type: 'wallet',
    description: 'Digital Wallet Payment Gateway',
  },
  PY_BLOM_UC: {
    logo: PAY_CONNECT_CDN_LOGOS.PY_BLOM_UC,
    color: '#003DA5',
    backgroundColor: '#E8EAF6',
    name: 'BLOM Card',
    type: 'card',
    description: 'Visa & Mastercard Payments',
  },
  PY_OMT: {
    logo: PAY_CONNECT_CDN_LOGOS.PY_OMT,
    color: '#FF6B00',
    backgroundColor: '#FFF3E0',
    name: 'OMT Wallet',
    type: 'wallet',
    description: 'Digital Wallet & Payment Services',
  },
}

export function getVendorGatewayMeta(factoryName: string): VendorGatewayLogoMeta | null {
  return vendorGatewayLogos[factoryName] || null
}

export default vendorGatewayLogos
